import React, { useEffect, useMemo, useRef } from 'react';
import { Spin, Empty, Tag } from 'antd';
import moment from 'moment';

export const formatStudentName = (conversation) => {
  if (!conversation) return 'Unknown';
  const name = `${conversation.first_name || ''} ${conversation.last_name || ''}`.trim();
  return name || 'Unknown';
};

const ChatTranscript = ({ messages, loading, conversation }) => {
  const bottomRef = useRef(null);

  const visibleMessages = useMemo(
    () => messages.filter((msg) => msg.role !== 'system'),
    [messages]
  );

  useEffect(() => {
    if (!loading && visibleMessages.length > 0) {
      bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [loading, visibleMessages, conversation?.conversation_id]);

  if (!conversation) {
    return (
      <div className="ai-coach-empty">
        <Empty description="Select a conversation to view messages" />
      </div>
    );
  }

  return (
    <div className="ai-coach-transcript">
      <h3 className="ai-coach-transcript-title">{formatStudentName(conversation)}</h3>
      <Spin spinning={loading}>
        {!loading && visibleMessages.length === 0 ? (
          <Empty description="No messages in this conversation" />
        ) : (
          <div className="ai-coach-transcript-scroll">
            <ul className="ai-coach-message-list">
              {visibleMessages.map((msg, index) => {
                const isPlayer = msg.role === 'player';
                return (
                  <li
                    key={msg.sequence_num ?? index}
                    className={`ai-coach-bubble-row ${isPlayer ? 'ai-coach-bubble-row--left' : 'ai-coach-bubble-row--right'}`}
                  >
                    <div
                      className={`ai-coach-bubble ${isPlayer ? 'ai-coach-bubble--player' : 'ai-coach-bubble--assistant'}`}
                    >
                      <p className="ai-coach-bubble__content">{msg.content}</p>
                      {msg.created_at && (
                        <span className="ai-coach-bubble__time">
                          {moment(msg.created_at).format('MMM D, h:mm A')}
                        </span>
                      )}
                      {msg.escalated && msg.escalation_reason && (
                        <Tag className="ai-coach-bubble__escalation" color="volcano">
                          {msg.escalation_reason}
                        </Tag>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
            <div ref={bottomRef} aria-hidden="true" />
          </div>
        )}
      </Spin>
    </div>
  );
};

export default ChatTranscript;
